import request from '@/shared/api/request';

export const cancelTeamMemberInvite = ({
  uuid,
  email,
}: {
  uuid: string;
  email: string;
}): Promise<unknown> =>
  request({
    url: `/teams/${uuid}/invitations/cancel/`,
    method: 'POST',
    data: { email },
  });
